import React from 'react';
import SideBySideLayoutBlade from '@organic-return/foundation-react/src/components/Blades/SideBySideLayoutBlade';
import { graphql } from 'gatsby';

const SideBySideLayoutSection = (props: any) => {    
    let isRightColLarger = props?.largerColumn == "right";

    return (        
        <SideBySideLayoutBlade
            rightColumnLarger={isRightColLarger}
            leftColumn={{
                header: props?.leftColumnTitle,
                text: props?.leftColumnText,
                columnImage: {
                    url: props?.leftColumnImage.url,
                }
            }}
            rightColumn={{
                header: props?.rightColumnTitle,
                text: props?.rightColumnText,
                columnImage: {
                    url: props?.rightColumnImage.url,
                }
            }} 
        />
    );
}

export default SideBySideLayoutSection

export const query = graphql`
fragment DrupalSideBySideLayoutBladeContent on DrupalSideBySideLayoutBlade {    
    id
    blocktype
    largerColumn
    leftColumnImage {
      url
    }
    leftColumnText
    leftColumnTitle
    rightColumnImage {
      url
    }
    rightColumnText
    rightColumnTitle
}
`
